import { useEffect, useState } from 'react'

export const usePreloadImage = (src: string, onLoad?: () => void) => {
    const [hasLoaded, setHasLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [hasStartedInitialFetch, setHasStartedInitialFetch] = useState(false)

    useEffect(() => {
        if (!src) return

        setHasStartedInitialFetch(true)
        setHasLoaded(false)
        setHasError(false)

        // Here's where the magic happens.
        const image = new Image()
        image.src = src

        const handleError = () => {
            setHasError(true)
        }

        const handleLoad = () => {
            setHasLoaded(true)
            setHasError(false)
            onLoad?.()
        }

        image.onerror = handleError
        image.onload = handleLoad

        return () => {
            image.removeEventListener('error', handleError)
            image.removeEventListener('load', handleLoad)
        }
    }, [src, onLoad])

    return { hasLoaded, hasError, hasStartedInitialFetch }
}
